import { combineReducers } from 'redux';

import instancedReducer from './instancedReducer';

// This builds on instancedReducers to go a step further and combine a set of
// instancedReducers together so that we can easily access them as
// getState().<instanced-reducer-name>.<context-name>,
// or as getState().<instanced-reducer-name>[contextStringVar].
export default function(reducerFunction, reducerContexts) {
  // Generate an object with a key for each context that maps to a contextReducer
  // matching the context key.
  const reducers = reducerContexts.reduce((reducers, context) => {
      reducers[context] = instancedReducer(reducerFunction, context);
      return reducers;
    },
    {}
  );

  return combineReducers(reducers);
}



// WEBPACK FOOTER //
// ./src/store/indexedReducer.js